import { PaginationProps, SortDirection } from '@touche-lts/panel-ui/dist/utilities'
import {
  LegalTableSearchProps,
  LegalTableSortProps
} from './legal-table-store.types'

export const initialLegalTablePaginationProps: PaginationProps<LegalTableSortProps> = {
  page: 0,
  size: window.innerWidth >= 1920 ? 10 : 6,
  sortDirection: SortDirection.ASC,
  sortProp: LegalTableSortProps.TITLE,
  totalElements: 0,
  totalPages: 0
}

export const initialLegalTableSearchProps: LegalTableSearchProps = {
  title: '',
  status: 'ACTIVE',
  createdDate: undefined
}

export const legalTableNeedTimeoutSearchProps: Array<keyof LegalTableSearchProps> = [
  'title', 'status'
]
